import React from 'react';
import { useNavigate } from 'react-router-dom';

const Header = ({ children }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/dashboard');
  };

  return (
    <header className="flex shrink-0 flex-col items-stretch border-b border-black/[0.08] bg-white">
      <div className="flex shrink-0 items-center px-4 py-2">
        <button
          type="button"
          className="flex h-[34px] cursor-pointer items-center rounded-md border-0 bg-transparent p-0 touch-manipulation [tap-highlight-color:transparent] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--focus-ring,#0070f3)] focus-visible:outline-offset-2"
          onClick={handleLogoClick}
          aria-label="Go to dashboard"
        >
          <img
            src="/images/BenX_Logo.webp"
            alt=""
            height={34}
            decoding="async"
            className="block h-full max-h-[34px] w-auto object-contain"
          />
        </button>
      </div>
      {children ? (
        <div className="box-border w-full min-w-0 overflow-x-auto overflow-y-hidden border-t border-black/[0.08] bg-[#fafafa] px-4 py-[0.65rem] [-ms-overflow-style:none] [scrollbar-width:none] sm:px-5 sm:py-3 sm:pb-[0.85rem] [&::-webkit-scrollbar]:hidden">
          {children}
        </div>
      ) : null}
    </header>
  );
};

export default Header;
